module.exports = __webpack_public_path__ + "21f459645e4659430dd71c2ae821cd9c.svg";